import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./auth/baseQueryWithReauth";

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  // TIP-609/610 — an order (TIP-611) invalidates all three: the card must not
  // survive the brief it just spent, and the new row has to appear in the list.
  // "Purchase" — what the viewer has bought for one company. Buying a Web
  // Profile or spending a credit makes that read stale everywhere at once, and
  // the company profile screen is driven by it: without the tag the cached
  // answer survives the purchase and the masthead keeps offering to sell what
  // the viewer has just paid for, until the browser is refreshed. Keyed by
  // companyID. See FINDINGS F-099.
  // "User" was declared here from the start and never provided by anything;
  // the viewer's own individual record now carries it, because a spent credit
  // is deducted from that record.
  // "SubIndustries" — the id→name catalogue the company cards resolve against.
  // The tag was already declared on the endpoint (companyApiSlice) and NOT
  // here, which made it inert and logged a dev-only RTK Query error on every
  // fetch; F-099 recorded it. Declared now that a screen depends on the read.
  // "Company" — one company's own record, keyed by companyID. ICC-01 hands
  // the company over the moment the claim resolves, so every cached read of
  // that company is wrong from that instant: the profile screen kept showing
  // it as unclaimed, with the Claim button still offered, until a hard
  // refresh. Provided by the profile's company-details read.
  tagTypes: [
    "User",
    "Company",
    "Purchase",
    "SubIndustries",
    "BriefsAllowance",
    "BriefsList",
    "BriefDetail",
    "UserSessions",
  ],
  endpoints: (builder) => ({}),
});
